<bb-page-header 
[icon]="'table'"
[title]="'DATAFEEDS' | translate" 
[filterConfig]="filterConfig"
[currentPath]="listConfiguration.activePath">
</bb-page-header>
<div class="body-column">

	<div class="action-buttons">
		<a class="button" [routerLink]="['/library/datafeed', 'new', 'metadata']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_DATAFEED' | translate }}</span>
		</a>
	</div>
	
	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="name">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate"class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row" (dblclick)="redirectToDetails(row.id)">
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell property="name" class="overflow">{{ row.data.name }}</bb-table-cell>
			<bb-table-cell property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="buttons" (click)="$event.stopPropagation()"><!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/library/datafeed', row.data.id, 'metadata']">
					<i class="fa fa-edit" (easterEgg)="showData(row.data.id)" ></i>
				</a>

				<a class="button root" *ngIf="putRight" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_DATAFEEDS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>
	
</div>
